import { formatDate } from "@angular/common";

export const DATE_TIME_DISPLAY_FORMAT = "d MMM yyyy 'at' h:mm a";

export function formatDateTimeDisplay(
    value: string | Date | null | undefined,
    fallback = "-"
): string {
    if (!value) {
        return fallback;
    }

    const parsed = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return fallback;
    }

    try {
        return formatDate(parsed, DATE_TIME_DISPLAY_FORMAT, "en-US");
    } catch (error) {
        return fallback;
    }
}
